import { Component } from '@angular/core';
import { BankAccountKycDialogComponent } from './bank-account-kyc-dialog.component';
import { BankAccountKycDialogStateService } from '../../../../services/stripe-treasury/bank-account-kyc-dialog-state.service';

@Component({
    selector: 'app-bank-account-kyc-dialog-host',
    standalone: true,
    imports: [BankAccountKycDialogComponent],
    template: '<app-bank-account-kyc-dialog [open]="state.open()" (closed)="state.answer($event)"></app-bank-account-kyc-dialog>',
})
export class BankAccountKycDialogHostComponent {
    constructor(readonly state: BankAccountKycDialogStateService) {}
}
